import React from "react";
import { contact } from "../data/portfolio";

const Field = ({ label, children }) => (
  <div className="flex items-center gap-2 border-b border-[#808080] px-2 py-1.5">
    <span className="w-16 shrink-0 text-xs font-bold">{label}</span>
    <div className="win-sunken-thin min-w-0 flex-1 truncate px-2 py-1 text-xs">{children}</div>
  </div>
);

const ContactWindow = () => {
  return (
    <div className="flex h-full flex-col bg-[#c0c0c0] font-ui text-win-text">
      <div className="win-raised m-2 flex flex-wrap gap-1.5 p-1.5">
        <a
          href={`mailto:${contact.email}`}
          className="win-btn win-focus-dotted flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold"
        >
          📨 Send
        </a>
        <a
          href={contact.linkedin}
          target="_blank"
          rel="noopener noreferrer"
          className="win-btn win-focus-dotted flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold"
        >
          🔗 LinkedIn profile
        </a>
      </div>

      <div className="win-sunken-thin mx-2 mb-2 flex flex-1 flex-col overflow-hidden">
        <Field label="To:">{contact.email}</Field>
        <Field label="Cc:">{contact.location}</Field>
        <Field label="Subject:">{contact.headline}</Field>

        <div className="flex-1 overflow-auto p-3">
          <p className="text-sm leading-6">{contact.pitch}</p>

          <div className="mt-6 border-t border-dashed border-[#808080] pt-3 text-xs leading-6 text-[#404040]">
            <p>-- </p>
            <p className="font-bold">{contact.email}</p>
            <p>{contact.location}</p>
            <p>Focus: {contact.focus}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactWindow;
